import type { ReactNode } from 'react';

export const symbol_boy: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M437.5-697.6Q420-715.2 420-740.1t17.6-42.4q17.6-17.5 42.5-17.5t42.4 17.6q17.5 17.6 17.5 42.5t-17.6 42.4Q504.8-680 479.9-680t-42.4-17.6ZM420-190v-170h-10q-12.75 0-21.37-8.63Q380-377.25 380-390v-170q0-24.75 17.63-42.38Q415.25-620 440-620h80q24.75 0 42.38 17.62Q580-584.75 580-560v170q0 12.75-8.62 21.37Q562.75-360 550-360h-10v170q0 12.75-8.65 21.37-8.64 8.63-21.42 8.63h-60.15q-12.78 0-21.28-8.63-8.5-8.62-8.5-21.37Z"
		/>
	</svg>
);
